import { RolesContext } from "@/context/firestore/RolesProvider";
import { useContext } from "react";

export const useRoles = () => {
  const { roles, setRoles, rolesLoading } = useContext(RolesContext);
  return [roles, setRoles, rolesLoading] as const;
};
